/* assets/stock-status.js — keeps the availability band in sync with the selected variant.
   The states come from Shopify inventory rendered into the page by snippets/stock-status.liquid;
   nothing here invents, randomises or decrements a number. */
(function () {
  var LABELS = { in: 'In stock', low: 'Low stock', out: 'Out of stock' };

  function Band(root) {
    this.root = root;
    this.band = root.querySelector('[data-band]');
    this.label = root.querySelector('[data-label]');
    this.map = {};
    var json = root.querySelector('.stock-status__map');
    if (json) { try { this.map = JSON.parse(json.textContent) || {}; } catch (e) { this.map = {}; } }
    this.bindModal();
  }

  Band.prototype.set = function (variantId) {
    var state = this.map[String(variantId)];
    if (!state) return;
    this.root.setAttribute('data-state', state);
    if (this.label) this.label.textContent = LABELS[state] || LABELS.in;
  };

  Band.prototype.bindModal = function () {
    var modal = this.root.querySelector('[data-ss-modal]');
    if (!modal) return;
    var self = this;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('ss-modal-open');
      var x = modal.querySelector('[data-ss-close]');
      if (x) x.focus();
    }
    function close() {
      modal.hidden = true;
      document.documentElement.classList.remove('ss-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    var opener = self.root.querySelector('[data-ss-open]');
    if (opener) opener.addEventListener('click', open);
    modal.querySelectorAll('[data-ss-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  };

  function init(scope) {
    (scope || document).querySelectorAll('boostly-stock-status').forEach(function (el) {
      if (el.__ssBand) return;
      el.__ssBand = new Band(el);
    });
  }

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('boostly-stock-status').forEach(function (el) {
      if (el.__ssBand) el.__ssBand.set(v.id);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
